module.exports = __webpack_public_path__ + "static/img/cangku3.e660f53d.png";